// extracted by mini-css-extract-plugin
export var base = "_20-0";
export var updateBanner = "_20-1";